import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';
import { useAuth } from '../lib/auth-context.js';
export function StaffPage() {
    const { group, user } = useAuth();
    if (user.role !== 'admin' && user.role !== 'super_admin')
        return _jsx("p", { children: "\u062F\u0633\u062A\u0631\u0633\u06CC \u0646\u062F\u0627\u0631\u06CC\u062F." });
    const { data } = useQuery({ queryKey: ['users', group.id], queryFn: () => api('/api/users') });
    return (_jsxs("div", { children: [_jsx("h1", { className: "text-2xl mb-4", children: "\u06A9\u0627\u0631\u06A9\u0646\u0627\u0646" }), _jsx("ul", { className: "bg-white rounded shadow divide-y", children: (data?.users ?? []).map((u) => (_jsxs("li", { className: "p-3 flex justify-between", children: [_jsx("span", { children: u.display_name }), _jsx("span", { className: "text-sm text-slate-500", children: u.role })] }, u.id))) })] }));
}
